<div class="content">
  <button (click)="goto()">前往绑定</button>
</div>
